:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._tooltipContainer_rcjsv_7 {
  display: flex;
  align-items: center;
  position: absolute; }

._container_rcjsv_12 {
  position: absolute;
  left: -20px;
  width: 40px;
  height: 24px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.15), 0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 1px 18px 0 rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-color);
  color: var(--icon-color);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  pointer-events: all;
  cursor: ns-resize; }
  ._mobileEditor_rcjsv_28 ._container_rcjsv_12 {
    width: 30px;
    left: auto;
    margin-left: -15px; }

._legacy_rcjsv_33 {
  --bg-color: #6f56f9;
  --icon-color: #fff;
  --border-color: #6f56f9; }

._legacySoap_rcjsv_38 {
  --bg-color: #fe620f;
  --icon-color: #fff;
  --border-color: #fe620f; }
